import { Injectable, ErrorHandler, Injector } from "@angular/core"; 
import { AppInsightSvc } from "./services/appInsights.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
 
    constructor(private injector: Injector) { 

    }

    handleError(error: Error) {
        console.warn("GlobalErrorHandler.handleError", error);
        const appInsights = this.injector.get(AppInsightSvc);
        appInsights.trackException(error);

        alert("Unhandled Error: " + error);
    }
}